import { bindable, BindingMode, inject } from "aurelia";

@inject(Element)
export class PopOverCustomElement {
  @bindable title;
  @bindable content;
  @bindable load;

  constructor(element, ea) {
    this.element = element;
    this.ea = ea;
    this.opts = {
      trigger: "hover",
      placement: "top",
      html: true,
    };
  }

  attached() {
    this.afterAttached();
  }

  async afterAttached() {
    if (this.load) {
      const data = await this.load;
      this.createPopover(data.title, data.content);
    } else {
      this.createPopover();
    }
  }

  detaching() {
    // Removes the popover from <body> as well, see the pop-over attribute.
    $(this.element).popover("dispose");
  }

  createPopover(title, content) {
    $(this.element).popover("dispose");
    this.opts.content = this.content;
    if (content) {
      this.opts.content = content;
    }

    this.opts.title = this.title;
    if (title) {
      this.opts.title = title ?? "";
    }
    // No title binding and no grants give undefined, which Bootstrap rejects.
    if (this.opts.title == null) this.opts.title = "-";

    let attrs = this.element.attributes;
    if (attrs["data-placement"])
      this.opts.placement = attrs["data-placement"].value;
    if (attrs["data-trigger"]) this.opts.trigger = attrs["data-trigger"].value;

    $(this.element).popover(this.opts);

    if (attrs["data-hide-on-click"]) {
      this.element.addEventListener("click", () => {
        $(this.element).popover("hide");
      });
    }
  }
}
